var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5385_46839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49992 5.00033H9.16659C9.16659 3.16283 7.67075 1.66699 5.83325 1.66699V3.33366C6.75325 3.33366 7.49992 4.08199 7.49992 5.00033Z",
    fill: "#1AA04B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10.834V12.5007C15.92 12.5007 16.6667 13.249 16.6667 14.1673H18.3333C18.3333 12.3298 16.8383 10.834 15 10.834Z",
    fill: "#1AA04B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3087 1.86921L11.691 1.46484L10.8579 4.79795L12.4755 5.20231L13.3087 1.86921Z",
    fill: "#1AA04B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5352 8.30955L18.1317 6.69336L14.7983 7.52552L15.2017 9.14171L18.5352 8.30955Z",
    fill: "#1AA04B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70164 5.99316C7.06914 5.99316 6.67997 6.25066 6.46497 6.46483C6.26997 6.66066 1.84664 16.9148 1.73664 17.169C1.59914 17.4823 1.66831 17.8482 1.91081 18.0898C2.15414 18.3332 2.51997 18.4015 2.83247 18.2648C3.08914 18.1532 13.3383 13.7332 13.535 13.5365C14.75 12.3215 13.4708 9.93566 11.7675 8.23316C10.3875 6.8515 8.82831 5.99316 7.70164 5.99316ZM12.3416 12.3032C11.7158 12.5748 9.90581 11.0857 9.41081 10.5898C8.90914 10.089 7.43081 8.27733 7.69831 7.66066H7.70081C8.26664 7.66066 9.43997 8.26233 10.5891 9.41233C11.9308 10.7523 12.3541 11.9182 12.3416 12.3032ZM6.73331 9.87733C7.13247 10.5382 7.65664 11.1923 8.23331 11.769C8.84831 12.3848 9.4983 12.889 10.1308 13.2673L4.11164 15.8898L6.73331 9.87733Z",
    fill: "#1AA04B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2553 3.92286L16.0773 2.74512L14.4111 4.41175L15.5892 5.5895L17.2553 3.92286Z",
    fill: "#1AA04B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5385_46839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.f5c0adfea31cb865784fda242ab7ab6c.svg";
export { ForwardRef as ReactComponent };